import * as React from "react";

function SvgSendInBlue(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 300 300"
      {...{ ...props, ref }}
    >
      <path data-name="Rectangle 324" fill="none" d="M0 0h300v300H0z" />
      <path
        data-name="Path 2959"
        d="M261.369 214.726a59.531 59.531 0 01-35.006 27.454 80.01 80.01 0 00-57.51-100.062 58.964 58.964 0 0170.826-8.8 59.848 59.848 0 0121.69 81.407m-111.481 64.729a59.319 59.319 0 01-41.124-16.74 79 79 0 0020.8-8.384c32.378-18.8 46.581-57.13 36.6-91.72a59.616 59.616 0 0142.982 57.254c0 32.853-26.587 59.59-59.257 59.59M38.401 214.726a60.074 60.074 0 01-6.124-44.136 80.236 80.236 0 0017.6 13.876 78.879 78.879 0 0039.711 10.72 79.752 79.752 0 0057.587-24.649 59.793 59.793 0 01-27.826 66 58.649 58.649 0 01-29.528 7.97 59.245 59.245 0 01-51.42-29.781m0-129.457a59.531 59.531 0 0135.007-27.455 79.986 79.986 0 0057.475 100.053 59.379 59.379 0 01-92.482-72.599M149.888 20.54a59.275 59.275 0 0141.106 16.726 80.1 80.1 0 00-57.409 100.114 59.612 59.612 0 01-42.956-57.244c0-32.861 26.581-59.6 59.26-59.6m111.48 64.732a60.049 60.049 0 016.112 44.189 79.643 79.643 0 00-17.587-13.929 79.209 79.209 0 00-97.322 13.985 59.734 59.734 0 0127.85-66.059 59.076 59.076 0 0180.947 21.814m17.69-10.265a79.216 79.216 0 00-48.389-37.339 80.023 80.023 0 00-14.852-2.513 79.383 79.383 0 00-131.829-.009 80.111 80.111 0 00-71.242 100.669A81.215 81.215 0 0018.012 150a80.843 80.843 0 002.7 75 79.6 79.6 0 0063.2 39.808 79.394 79.394 0 00131.873.044 80.1 80.1 0 0065.959-114.814 80.853 80.853 0 00-2.681-75.035"
        fill="#0092ff"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default React.forwardRef(SvgSendInBlue);
